<script lang="ts" setup>
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})

const columnizedItems = computed(() => {
  const items = props.slice?.FAQ?.FaqItems || []

  const columns = props.slice?.Columns || 1

  const numColumns = Math.max(1, columns)

  const result = Array.from({ length: numColumns }, () => [] as typeof items)

  items.forEach((item, index) => {
    const columnIndex = index % numColumns
    result[columnIndex].push(item)
  })

  return result
})
</script>

<template>
  <StrapiSlice
    v-if="slice?.FAQ?.FaqItems?.length"
    class="ct-faq"
    :slice="slice"
    :index="index"
    variant="horizontal"
    :style="`--columns: ${columnizedItems.length};`"
  >
    <div
      v-for="(column, columnIndex) in columnizedItems"
      :key="`column-${columnIndex}`"
      class="ct-faq__column"
    >
      <UiCollapsable
        v-for="(item) in column"
        :key="item.Question"
        :label="item.Question"
        :open="item.Open"
      >
        <template #icon_after="{ open }">
          <NuxtIcon
            :name="open ? 'icon:min' : 'icon:plus'"
            class="collapsable__icon icon icon--min"
            :class="`icon--${open ? 'min' : 'plus'}`"
          />
        </template>

        <StrapiBlocksText
          v-if="item?.Answer?.length"
          :nodes="item.Answer"
        />
      </UiCollapsable>
    </div>
  </StrapiSlice>
</template>

<style>
@import url("~layers/components/Slices/Faq.css");
</style>
